import { getClientApiUrl, postJson } from '@avensia/excite';
import { registrationEvent } from '../events';

export async function changeCustomerFirstName(firstName: string) {
  const { send } = await import('./command');
  return send({
    $type: 'SetFirstNameCommand',
    firstName,
  });
}

export async function changeCustomerLastName(lastName: string) {
  const { send } = await import('./command');
  return send({
    $type: 'SetLastNameCommand',
    lastName,
  });
}

export async function changeCustomerEmail(email: string) {
  const { send } = await import('./command');
  return send({
    $type: 'ChangeCustomerEmailCommand',
    email,
  });
}

export async function setDateOfBirth(dateOfBirth: string | undefined) {
  const { send } = await import('./command');
  return send({
    $type: 'SetDateOfBirthCommand',
    dateOfBirth,
  });
}

export async function changeMobileNumber(mobileNumber: string) {
  const { send } = await import('./command');
  return send({
    $type: 'ChangeMobileNumberCommand',
    mobileNumber,
  });
}

export type CustomerAddressType = Omit<Excite.Commercetools.ChangeAddressCommand, '$type'>;
export async function setCustomerAddress(address: CustomerAddressType) {
  const { send } = await import('./command');
  return send({
    $type: 'ChangeAddressCommand',
    ...address,
  });
}

export type ChangePasswordType = Omit<Excite.Commercetools.ChangePasswordCommand, '$type'>;

export async function changePassword(changePassword: ChangePasswordType) {
  const response: Excite.Commercetools.CustomerCommandResponse = await postJson(
    getClientApiUrl('ct/customer/changepassword'),
    {
      $type: 'ChangePasswordCommand',
      ...changePassword,
    } as Excite.Commercetools.ChangePasswordCommand,
  );
  return response;
}

export type ResetPasswordType = Omit<Excite.Commercetools.ResetPasswordCommand, '$type'>;

export async function resetPassword(resetPassword: ResetPasswordType) {
  const response: Excite.Commercetools.CustomerCommandResponse = await postJson(
    getClientApiUrl('ct/customer/resetpassword'),
    {
      $type: 'ResetPasswordCommand',
      ...resetPassword,
    } as Excite.Commercetools.ResetPasswordCommand,
  );
  return response;
}

export type ForgotPasswordType = Omit<Excite.Commercetools.ForgotPasswordCommand, '$type'>;

export async function forgotPassword(forgotPassword: ForgotPasswordType) {
  const response: Excite.Commercetools.CustomerCommandResponse = await postJson(
    getClientApiUrl('ct/customer/forgotpassword'),
    {
      $type: 'ForgotPasswordCommand',
      ...forgotPassword,
    } as Excite.Commercetools.ForgotPasswordCommand,
  );
  return response;
}

export async function createCustomer(custmerInfo: Excite.Commercetools.ICustomerRegistrationRequest) {
  const response: Excite.Commercetools.CustomerCommandResponse = await postJson(
    getClientApiUrl('ct/customer/register'),
    custmerInfo,
  );
  if (response.success) {
    await registrationEvent.emit();
  }
  return response;
}
